'use client'

import { useNavigate } from 'react-router-dom'
import { WizardFooter } from '@repo/ui/WizardFooter'
import { WizardPanel } from '@repo/ui/WizardPanel'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'

type StepProps = {
  wideMode?: boolean
  handlePrevNext: (delta: number) => void
  updateStepState: (changes: { status?: string; statusText?: string }) => void
  testMode?: boolean
}

export const MapFieldsStep = ({ wideMode, handlePrevNext, updateStepState }: StepProps) => {
  const navigate = useNavigate()

  const handleSave = async () => {
    await updateStepState({ status: 'completed', statusText: 'Complete' })
    navigate('?')
  }

  return (
    <>
      <WizardPanel data-testid="MapFieldsStep">
        <MUIStack gap={2}>
          <MUITypography variant="body1" sx={{ fontWeight: 600 }}>
            Map fields
          </MUITypography>
          <MUITypography variant="body2" color="text.secondary">
            Coming soon.
          </MUITypography>
        </MUIStack>
      </WizardPanel>

      <WizardFooter
        wideMode={wideMode}
        handleClickContinue={handleSave}
        handleClickBack={() => handlePrevNext(-1)}
        continueButtonText="Save"
      />
    </>
  )
}
